module.exports = __webpack_public_path__ + "img/img_jisu_20201207@2x.4ceafb3f.png";